import { cleanObject } from '@shared/utils';
import getPieveCompanyIdForRequest from '@/lib/auth/getPieveCompanyIdForRequest.js';
import { del, get, post, put } from '@/redux/requests/api.js';

export const getSkills = ({ limit = 200, cursor = null, pinned = null, status = 'active', query = null } = {}, callback) => {
  const companyId = String(getPieveCompanyIdForRequest() || '').trim() || null;
  return get('/v1/pieve/knowledge', {
    action: 'GET_SKILLS',
    loader: 'getSkills',
    callback,
    meta: {
      companyId
    },
    query: {
      documentKind: 'skill',
      limit,
      cursor,
      pinned,
      status,
      q: query,
      includeShareInvitations: 'true'
    }
  });
};

export const shareSkill = ({ skillId, email } = {}, callback) => {
  return post(`/v1/pieve/knowledge/${encodeURIComponent(String(skillId || '').trim())}/share`, {
    action: 'SHARE_SKILL',
    loader: 'shareSkill',
    callback,
    data: {
      email: String(email || '').trim()
    }
  });
};

export const acceptSharedSkill = ({ skillId } = {}, callback) => {
  return post(`/v1/pieve/knowledge/${encodeURIComponent(String(skillId || '').trim())}/accept-share`, {
    action: 'ACCEPT_SHARED_SKILL',
    loader: 'acceptSharedSkill',
    callback
  });
};

export const getSkill = ({ nodeId } = {}, callback) => {
  return get(`/v1/pieve/knowledge/${encodeURIComponent(String(nodeId || '').trim())}`, {
    action: 'GET_SKILL',
    loader: 'getSkill',
    callback,
    query: {
      documentKind: 'skill',
      includeContent: 'true'
    }
  });
};

export const setSkillPinned = ({ skillId, pinned = false } = {}, callback) => {
  return put(`/v1/pieve/knowledge/${encodeURIComponent(String(skillId || '').trim())}`, {
    action: 'SET_SKILL_PINNED',
    loader: 'setSkillPinned',
    callback,
    data: {
      pinned: pinned === true
    }
  });
};

export const updateSkill = ({ skillId, title, scope, scopeRef, callable, status, description, tags, entrypoint, icon, iconColor, iconSource, metadata, pinned } = {}, callback) => {
  const meta = cleanObject({ title, description, scope, scopeRef, callable, status, entrypoint, icon, iconColor, iconSource, tags, ...metadata }, { strict: true });

  return put(`/v1/pieve/knowledge/${encodeURIComponent(String(skillId || '').trim())}`, {
    action: 'UPDATE_SKILL',
    loader: 'updateSkill',
    callback,
    data: cleanObject({ pinned, meta: Object.keys(meta).length > 0 ? meta : undefined }, { strict: true })
  });
};

export const getKnowledgeByPath = ({ path } = {}) => {
  return get('/v1/pieve/knowledge', {
    action: 'GET_KNOWLEDGE_BY_PATH',
    loader: 'getKnowledgeByPath',
    query: { path }
  });
};

export const removeSkill = ({ skillId } = {}, callback) => {
  return del(`/v1/pieve/knowledge/${encodeURIComponent(String(skillId || '').trim())}`, {
    action: 'REMOVE_SKILL',
    loader: 'removeSkill',
    callback,
    meta: {
      skillId: String(skillId || '').trim()
    }
  });
};
